if($(".canvi-content").length >0){
    
    var canvi = new Canvi({
        content: '.canvi-content',
        navbar: '.canvi-navbar',
        openButton: '.js-canvi-open-button--left',
        width: '320px',
        position: 'left',
        pushContent: true
    });

    $(".canvi-navbar").addClass("invisible");

    $('.close-navbar').on('click', function(){
        canvi.close();
    });

    document.querySelector('body').addEventListener('canvi.after-close', function(e) {
        $(".canvi-navbar").addClass("invisible");
    });

    document.querySelector('body').addEventListener('canvi.before-open', function(e) {
        $(".canvi-navbar").removeClass("invisible");
    });

    $(".has-submenu").click(function(){
        const $this = $(this);
        $(".canvi-navbar").find(".has-submenu.active").not(this).removeClass("active");

        if(!$this.hasClass("active")){
            $this.addClass("active");
        }else{
            $this.removeClass("active");
        }
    })
}